import React, { forwardRef, useMemo } from 'react';
import { Link } from '@tanstack/react-router';

export const UniversalTanstackRouterLink = forwardRef<HTMLAnchorElement, any>(
  ({ href, to, ...props }, ref) => {
    const url: string | undefined = to || href;

    const clientNavigation = useMemo(() => {
      if (!url?.length || !url.startsWith('/')) {
        return;
      }

      const urlObject = new URL(url, window.location.origin);

      /**
       * We can't pass a full url to the 'to' prop tanstack router Link.
       * We need to break it down into the individual components.
       */
      const pathname = urlObject.pathname;
      // Remove the hash from the url otherwise tanstack link component will double it up
      const hash = urlObject.hash.replace('#', '');
      const search = Object.fromEntries(
        new URLSearchParams(urlObject.search).entries()
      );

      return {
        pathname,
        hash,
        search,
      };
    }, [url]);

    if (clientNavigation) {
      return (
        <Link
          {...props}
          // Forwarded on both branches: consumers that treat this as the
          // underlying element — Radix's `asChild`, for one — need the node to
          // register it, and silently lose it on a client-navigation url.
          ref={ref}
          hash={clientNavigation.hash}
          search={clientNavigation.search}
          to={clientNavigation.pathname}
        />
      );
    }

    return <a ref={ref} href={url} {...props} />;
  }
);

UniversalTanstackRouterLink.displayName = 'UniversalTanstackRouterLink';
